<template>
    <div id="element-container">
        <div v-if="loading" class="loader-container">
            <page-loader :loading="loading"></page-loader>
        </div>
        <div v-else-if="hasActiviteiten"
             class="columns is-multiline mt-1">
            <div v-for="activiteit in activiteiten"
                 :key="activiteit.activiteitID"
                 class="column is-4"
                 @click="openActiviteit(activiteit.activiteitID)">
                <activiteit-block v-bind:activiteit="activiteit"></activiteit-block>
            </div>
        </div>
        <div v-else class="columns is-multiline mt-1">
            <div class="italic mt-8 text-lg has-text-centered w-full">
                Er zijn geen activiteiten gevonden
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import ActiviteitBlock from './ActiviteitBlock';
  import { size } from 'lodash-es';
  import PageLoader from '../PageLoader';

  export default {
    components: { ActiviteitBlock, PageLoader },

    data () {
      return {
        activiteiten: [],
        loading: true
      };
    },

    props: {
      count: {
        type: Number,
        default: 6
      }
    },

    computed: {
      hasActiviteiten () {
        return size(this.activiteiten) > 0;
      }
    },

    mounted: function () {
      this.fetchItems(this.count);
    },

    methods: {
      fetchItems: function (count) {
        axios
          .get('/api/v1/activiteiten', {
            params: { promotedThenlatest: true, limit: count }
          })
          .then(response => {
            this.activiteiten = response.data;
            this.loading = false;
          });
      },
      openActiviteit: function (activiteitID) {
        window.location = '/activiteiten/' + activiteitID;
      }
    }
  };
</script>